// frontend/src/components/Auth/ResendVerification.jsx - NOUVEAU FICHIER

import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert, InputGroup } from 'react-bootstrap';
import { FaEnvelope, FaPaperPlane } from 'react-icons/fa';
import { useNavigate, Link } from 'react-router-dom';
import api from '../../services/api';
import { toast } from 'react-toastify';

const ResendVerification = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            await api.post('/user/resend-verification/', { email });
            setSuccess(true);
            toast.success('✅ Email envoyé avec succès !');
        } catch (error) {
            const errorMsg = error.response?.data?.error || 
                            error.response?.data?.message || 
                            'Erreur lors de l\'envoi';
            setError(errorMsg);
            toast.error('❌ ' + errorMsg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <Container className="py-5">
                <Card className="shadow-lg" style={{ maxWidth: '550px', margin: '0 auto' }}>
                    <Card.Body className="p-5">
                        <div className="text-center mb-4">
                            <div className="mb-3">
                                <FaEnvelope size={60} className="text-primary" />
                            </div>
                            <h2 className="mb-2">Renvoyer l'email de vérification</h2>
                            <p className="text-muted">
                                Entrez votre adresse email pour recevoir un nouveau lien de vérification
                            </p>
                        </div>

                        {error && (
                            <Alert variant="danger" className="mb-4">
                                {error}
                            </Alert>
                        )}

                        {success ? (
                            <Alert variant="success" className="text-center">
                                <FaPaperPlane size={40} className="text-success mb-3" />
                                <h5 className="mb-3">Email envoyé !</h5>
                                <p className="mb-3">
                                    Un email de vérification a été envoyé à <strong>{email}</strong>
                                </p>
                                <p className="text-muted mb-3">
                                    Vérifiez votre boîte de réception et vos spams. Le lien expire dans 24 heures.
                                </p>
                                <hr />
                                <div className="d-flex gap-2 justify-content-center">
                                    <Button 
                                        variant="primary" 
                                        onClick={() => navigate('/login')}
                                    >
                                        Aller à la connexion
                                    </Button>
                                    <Button 
                                        variant="outline-secondary"
                                        onClick={() => {
                                            setSuccess(false);
                                            setEmail('');
                                        }}
                                    >
                                        Renvoyer à nouveau
                                    </Button>
                                </div>
                            </Alert>
                        ) : (
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-4">
                                    <Form.Label>Adresse email</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Text>
                                            <FaEnvelope />
                                        </InputGroup.Text>
                                        <Form.Control
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                            placeholder="votre@email.com"
                                            size="lg"
                                        />
                                    </InputGroup>
                                    <Form.Text className="text-muted">
                                        Utilisez l'email avec lequel vous vous êtes inscrit
                                    </Form.Text>
                                </Form.Group>

                                <Button 
                                    type="submit" 
                                    variant="primary" 
                                    className="w-100"
                                    size="lg"
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2"></span>
                                            Envoi en cours...
                                        </>
                                    ) : (
                                        <>
                                            <FaPaperPlane className="me-2" />
                                            Renvoyer l'email
                                        </>
                                    )}
                                </Button>
                            </Form>
                        )}

                        <hr className="my-4" />

                        <div className="text-center">
                            <p className="text-muted mb-0">
                                <Link to="/login" className="text-primary">
                                    ← Retour à la connexion
                                </Link>
                            </p>
                        </div>
                    </Card.Body>
                </Card>

                <div className="text-center mt-4">
                    <p className="text-muted">
                        <strong>Astuce :</strong> Si vous ne recevez pas l'email, vérifiez votre dossier spam
                    </p>
                </div>
            </Container>
        </div>
    );
};

export default ResendVerification;